import { useLocation, useNavigate } from 'react-router-dom';
import { NavContext } from './nav';
import { SeasonHome } from './screens/SeasonHome';
import { Submit } from './screens/Submit';
import { RoundVote } from './screens/RoundVote';
import { Reveal } from './screens/Reveal';
import { Standings } from './screens/Standings';
import { Chat } from './screens/Chat';
import { AdminConsole } from './screens/Admin';
import { ProposeRound } from './screens/ProposeRound';
import { Presets } from './screens/Presets';
import { LeagueSettings } from './screens/LeagueSettings';
import { Members } from './screens/Members';

// The new app, assembled. Mounted at /app/* so every screen has a real,
// bookmarkable URL and the browser back button moves between them. The classic
// experience keeps its own top-level paths (see App.tsx) — untouched.
const SCREENS: Record<string, () => JSX.Element> = {
  home: SeasonHome,
  submit: Submit,
  vote: RoundVote,
  results: Reveal,
  standings: Standings,
  chat: Chat,
  admin: AdminConsole,
  propose: ProposeRound,
  presets: Presets,
  settings: LeagueSettings,
  members: Members,
};

// screen id ⇄ url segment under /app. The Table tab reads as /app/table; the rest
// match their id. Home is the bare /app.
const ID_TO_SEG: Record<string, string> = { home: '', standings: 'table' };
const SEG_TO_ID: Record<string, string> = { '': 'home', table: 'standings' };
const segFor = (id: string) => (id in ID_TO_SEG ? ID_TO_SEG[id] : id);
const idFor = (seg: string) => (seg in SEG_TO_ID ? SEG_TO_ID[seg] : seg);

export function DesignApp() {
  const location = useLocation();
  const navigate = useNavigate();
  const seg = location.pathname.replace(/^\/app\/?/, '').split('/')[0];
  const current = SCREENS[idFor(seg)] ? idFor(seg) : 'home';
  const Screen = SCREENS[current];
  const go = (id: string) => navigate('/app' + (segFor(id) ? '/' + segFor(id) : ''));
  return (
    <NavContext.Provider value={{ current, go }}>
      <Screen />
    </NavContext.Provider>
  );
}
